import React from 'react';

export function EmptySectionContent({ text = 'There is no information yet.' }) {
    return <div className="data-item-empty">{text}</div>;
}
